---
title: Datenschutz
updated: 2026-10-02
---

## 1. Verantwortlicher

Draughts Game („wir", „uns") ist der Verantwortliche für die über diese Plattform erhobenen personenbezogenen Daten. Kontakt: [privacy@draughtsgame.com](mailto:privacy@draughtsgame.com)

## 2. Daten, die Wir Erheben

### 2.1 Kontodaten

- **Benutzername** - von dir gewählt, öffentlich sichtbar
- **E-Mail-Adresse** - im Ruhezustand mit AES-256-GCM verschlüsselt, zur Kontoidentifikation verwendet, nicht öffentlich sichtbar
- **Passwort** - als bcrypt-Hash gespeichert (Kostenfaktor 12), niemals im Klartext
- **Altersbestätigung** - wir speichern, dass du bei der Registrierung bestätigt hast, mindestens 16 Jahre alt zu sein
- **E-Mail-Verifizierungsstatus** - ob du deine E-Mail-Adresse bestätigt hast, sowie kurzlebige Verifizierungs- und Passwort-Reset-Tokens
- **Profilanpassung (optional)** - Avatar und Land, von dir gewählt, öffentlich sichtbar

### 2.2 Spieldaten

- Züge, Ergebnisse und Zeitstempel der Partien
- Spieler-Ratings und Statistiken
- Turnierteilnahmen und -ergebnisse
- Versuche bei Taktikaufgaben, Aufgaben-Rating und Lösungsserien (Streaks)
- Deine Studienbibliothek: Stellungsnotizen (von dir geschriebener Freitext), Ordner, gespeicherte Partien und im Editor gespeicherte Stellungen — privat, nur für dich sichtbar

### 2.3 Technische Daten

- IP-Adresse (für Sicherheit und Anti-Cheating)
- User-Agent-String des Browsers
- Sitzungstokens

### 2.4 Supportanfragen

Wenn du uns über das Supportformular kontaktierst, erheben wir deine E-Mail-Adresse, optional einen Namen sowie Betreff und Inhalt deiner Nachricht, um deine Anfrage bearbeiten und beantworten zu können.

## 3. Rechtsgrundlage der Verarbeitung

Wir verarbeiten deine personenbezogenen Daten auf folgender Grundlage:

- **Vertragserfüllung** (Art. 6 Abs. 1 lit. b DSGVO) - zur Bereitstellung des Spieldienstes, für den du dich registriert hast, einschließlich Transaktions-E-Mails (Kontoverifizierung, Passwort-Zurücksetzung) und Supportantworten.
- **Berechtigte Interessen** (Art. 6 Abs. 1 lit. f DSGVO) - für Plattformsicherheit, Anti-Cheating, aggregierte Spielstatistiken (welche Varianten gespielt werden, wie Partien enden) und Verbesserung des Dienstes.
- **Einwilligung** (Art. 6 Abs. 1 lit. a DSGVO) - für die Nutzungsmessung über Umami und die Fehlerverfolgung über Sentry. Beides startet erst, wenn du im Banner zustimmst.

## 4. Wie Wir Deine Daten Verwenden

- Bereitstellung und Betrieb der Spielplattform
- Authentifizierung deines Kontos und Aufrechterhaltung von Sitzungen
- Berechnung und Anzeige von Spieler-Ratings und Ranglisten
- Matchmaking und Turnierorganisation
- Erkennung und Verhinderung von Betrug und Missbrauch
- Versand von Transaktions-E-Mails (Kontoverifizierung, Passwort-Zurücksetzung)
- Bearbeitung und Beantwortung deiner Supportanfragen
- Verbesserung des Dienstes durch aggregierte, anonyme Statistiken
- Analyse von Spieldaten (z. B. gespielte Varianten, Ergebnisse) in aggregierter, anonymisierter Form, um die Nutzung zu verstehen und die Plattform zu verbessern

## 5. Cookies und Dienste Dritter

Wir verwenden essenzielle Cookies für die Authentifizierung und deine Einstellungen. Wir nutzen die folgenden Dienste:

- **Umami** (Analyse) - selbst gehostet auf unserer eigenen EU-Infrastruktur. Es kommt ohne Cookies aus und startet nur, wenn du der Analyse im Banner zustimmst. Besuche werden über ein pseudonymes Kennzeichen erkannt, das aus deiner IP-Adresse und deinem Browser abgeleitet und täglich erneuert wird; die Zahlen werden ausschließlich aggregiert genutzt, und wir verfolgen dich nicht über andere Websites hinweg.
- **Sentry** (Fehlerverfolgung) - nur mit deiner Einwilligung aktiviert.
- **Resend** (E-Mail-Zustellung) - stellt unsere Transaktions-E-Mails (Kontoverifizierung, Passwort-Zurücksetzung) und Supportbenachrichtigungen zu.
- **DigitalOcean** (Hosting) - EU-Rechenzentrum (Frankfurt).

Wir verkaufen deine Daten nicht und verwenden keine Werbetracker.

## 6. Datenspeicherung

- **Kontodaten** - gespeichert, solange dein Konto aktiv ist.
- **Gastkonten** - werden nach 30 Tagen Inaktivität automatisch gelöscht.
- **Nicht bestätigte Konten** - wenn du dich registrierst, deine E-Mail-Adresse aber nie bestätigst, wird das Konto nach 30 Tagen Inaktivität automatisch gelöscht.
- **Refresh-Tokens** - laufen nach 7 Tagen ab (90 Tage bei Gastkonten, damit du deine Partien ohne Passwort wiederfindest), stündliche automatische Bereinigung. Die IP-Adresse und die Browser-Angaben einer Sitzung werden nach 7 Tagen gelöscht, auch wenn die Sitzung länger dauert.
- **E-Mail-Verifizierungstokens** - laufen nach 24 Stunden ab.
- **Passwort-Reset-Tokens** - laufen nach 1 Stunde ab.
- **Supportanfragen** - werden so lange gespeichert, wie es zur Bearbeitung deiner Anfrage erforderlich ist.
- **Missbrauchsmeldungen** - wenn ein Spieler jemanden wegen Chat-Missbrauchs meldet, wird der Chat dieser Partie (bis zu 100 Nachrichten, von beiden Spielern) zur Moderation gespeichert und nach 90 Tagen automatisch gelöscht. Ansonsten wird der Chat nie gespeichert.
- **Spieldaten** - werden unbegrenzt als Teil des öffentlichen Partiearchivs gespeichert.
- **Studienbibliothek** - Stellungsnotizen, Ordner, gespeicherte Partien und gespeicherte Stellungen bleiben, bis du sie löschst, und werden in jedem Fall mit der Kontolöschung entfernt.
- **Sentry-Fehlerdaten** - werden nach 90 Tagen automatisch gelöscht.
- **Gelöschte Konten** - personenbezogene Daten werden bei der Löschung sofort entfernt. Partieaufzeichnungen werden anonymisiert (Spielerbezug entfernt).

## 7. Deine Rechte (DSGVO)

Nach der Datenschutz-Grundverordnung (DSGVO) hast du das Recht auf:

- **Auskunft** (Art. 15) - lade eine Kopie deiner personenbezogenen Daten in den Profileinstellungen herunter („Meine Daten exportieren").
- **Berichtigung** (Art. 16) - ändere dein Passwort in den Profileinstellungen. Für andere Korrekturen kontaktiere uns.
- **Löschung** (Art. 17) - lösche dein Konto in den Profileinstellungen („Konto löschen"). Dies geschieht sofort und ist unwiderruflich.
- **Datenübertragbarkeit** (Art. 20) - exportiere deine Daten im maschinenlesbaren JSON-Format aus den Profileinstellungen.
- **Einschränkung** (Art. 18) - beantrage die Einschränkung der Verarbeitung, indem du uns kontaktierst.
- **Widerspruch** (Art. 21) - wenn du die Analyse im Cookie-Banner ablehnst, werden **sowohl** die Umami-Nutzungsmessung **als auch** die Sentry-Fehlerverfolgung abgeschaltet. Du kannst es jederzeit über den Schalter in den Profileinstellungen ändern.

Um eines dieser Rechte auszuüben, nutze die Selbstbedienungstools in deinen Profileinstellungen oder kontaktiere uns unter [privacy@draughtsgame.com](mailto:privacy@draughtsgame.com). Wir antworten innerhalb von 30 Tagen.

## 8. Datensicherheit

Wir setzen geeignete technische und organisatorische Maßnahmen zum Schutz deiner personenbezogenen Daten ein, darunter Verschlüsselung sensibler Daten im Ruhezustand und bei der Übertragung, sicheres Passwort-Hashing und Rate-Limiting bei Authentifizierungs-Endpunkten.

## 9. Internationale Datenübermittlungen

Deine Daten werden hauptsächlich im Europäischen Wirtschaftsraum (EWR) gespeichert und verarbeitet, im Frankfurter Rechenzentrum von DigitalOcean. Sentry-Fehlerdaten können auf Grundlage des Angemessenheitsbeschlusses zum EU-US Data Privacy Framework (Juli 2023) in die USA übermittelt werden. Du kannst Sentry in den Profileinstellungen deaktivieren. Transaktions-E-Mails werden über Resend (USA) zugestellt; diese Übermittlung ist durch einen Auftragsverarbeitungsvertrag mit Standardvertragsklauseln abgedeckt.

## 10. Datenschutz von Kindern

Der Dienst richtet sich nicht an Kinder unter 16 Jahren (Art. 8 DSGVO). Wir verlangen bei der Registrierung eine Altersbestätigung. Wir erheben wissentlich keine personenbezogenen Daten von Kindern unter 16 Jahren. Sollten wir erfahren, dass wir Daten eines Kindes unter 16 Jahren erhoben haben, werden wir diese umgehend löschen.

## 11. Änderungen dieser Richtlinie

Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Über wesentliche Änderungen informieren wir registrierte Nutzer durch einen Hinweis auf der Plattform. Das Datum „Zuletzt aktualisiert" oben zeigt die letzte Überarbeitung an.

## 12. Aufsichtsbehörde

Du hast das Recht, bei der zuständigen Datenschutz-Aufsichtsbehörde Beschwerde einzulegen, wenn du der Ansicht bist, dass deine Datenschutzrechte verletzt wurden.

## 13. Kontakt

Bei Fragen zu dieser Datenschutzerklärung:

- E-Mail: [privacy@draughtsgame.com](mailto:privacy@draughtsgame.com)
